module.exports = __webpack_public_path__ + "static/media/hubspotProcess3.cd130b1c.png";